import type { SerializableObject } from '@clientos/types';

/**
 * Error thrown when a context is not found
 */
export class EnvironmentVariableContextNotFoundError extends Error {
  public readonly context: string;

  constructor(context: string) {
    super(`Environment variable context not found: ${context}`);
    this.context = context;
    this.name = 'EnvironmentVariableContextNotFoundError';
  }
}

/**
 * Type for environment variables structure in manifest
 */
export interface EnvironmentVariablesManifestEntry {
  [context: string]: SerializableObject;
}

export type EnvironmentVariablesInputType = {
  [context: string]: Record<string, any>;
};
